import { AbstractControl, FormArray, FormGroup, ValidationErrors, ValidatorFn } from "@angular/forms";

function hasAtLeastOne(group: FormGroup, validator: ValidatorFn, controls: string[]) {
  return group && group.controls && controls.some(k => !validator(group.controls[k]));
}

export const photosValidator = (KEYS: string[]) => (control: AbstractControl): ValidationErrors | null => {
  const photos = control.value || [];
  const missingPhotos = KEYS.reduce((acc, curr) => {
    if (!photos[curr] || photos[curr].length === 0) acc.push(curr);
    return acc;
  }, []);
  return missingPhotos.length > 0 ? missingPhotos : null;
}

export function decimalWithPointValidator(): ValidatorFn {
  return (control: AbstractControl): ValidationErrors | null => {
    const isDeciamlWithPoint = /^[0-9]*(\.[0-9]+)?$/.test(control.value)
    return isDeciamlWithPoint ? null : { decimalWithPoint: true }
  }
}

export function integer(): ValidatorFn {
  return (control: AbstractControl): ValidationErrors | null => {
    const isInteger = /^[0-9]*$/.test(control.value);
    return isInteger ? null : { integer: true }
  }
}

export function splitterPortCoherenceValidator(): ValidatorFn {
  return (control: AbstractControl): ValidationErrors | null => {
    const splittingLevel = control.get('ss_livelloSplitteraggio')?.value;
    const splitterPort = control.get('ss_portaSplitterOut')?.value;

    if (!splittingLevel || splitterPort === null || splitterPort === undefined || splitterPort === '') {
      return null;
    }

    const maximumPort = Number(splittingLevel.toString().split('-')[1]);
    const port = Number(splitterPort);
    const isCoherent = Number.isFinite(port) && Number.isFinite(maximumPort) && port > 0 && port <= maximumPort;

    return isCoherent ? null : { splitterPortNotCoherent: true };
  };
}

export const atLeastOne = (validator: ValidatorFn, controls: string[] = null) => (group: FormGroup): ValidationErrors | null => {
  function checkHasAtLeastOne(group: FormGroup, validator: ValidatorFn, controls: string[]) {
    return group && group.controls && controls.some(k => !validator(group.controls[k]));
  }

  if (!controls) {
    controls = Object.keys(group.controls);
  }

  const hasAtLeastOne = checkHasAtLeastOne(group, validator, controls);

  return hasAtLeastOne ? null : { atLeastOne: true };
};

export const atLeastOneEveryArray = (validator: ValidatorFn, formArray: string, controls: string[]) => (group: FormGroup): ValidationErrors | null => {
  function checkHasAtLeastOne(group: FormGroup, validator: ValidatorFn, controls: string[]) {
    return group && group.controls && controls.some(k => !validator(group.controls[k]));
  }
  const hasAtLeastOne = group && group.controls && group.controls[formArray] && ((group.controls[formArray] as FormArray).controls.every(c => checkHasAtLeastOne((c as FormGroup), validator, controls)));

  return hasAtLeastOne ? null : { atLeastOne: true };
};

export const notAllEveryArray = (validator: ValidatorFn, formArray: string, controls: string[]) => (group: FormGroup): ValidationErrors | null => {
  function checkNotAll(group: FormGroup, validator: ValidatorFn, controls: string[]) {
    return group && group.controls && controls.some(k => validator(group.controls[k]));
  }
  const hasAtLeastOne = group && group.controls && group.controls[formArray] && ((group.controls[formArray] as FormArray).controls.every(c => checkNotAll((c as FormGroup), validator, controls)));

  return hasAtLeastOne ? null : { atLeastOne: true };
};

export function requiredAttachemntValidator(): ValidatorFn {
    return (control: AbstractControl): ValidationErrors | null => {
    const isForbidden = !!control?.value && control.value.split(',').length === 0;
    return isForbidden ? {missingAttachments: true} : null;
  };
}

